module.exports = __webpack_public_path__ + "img/arte-urbana.ca12ba29.jpg";